





























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "languageComponent",
  components: {},
})
export default class languageComponent extends Vue {
  public name: "languageComponent";
  @Prop({
    type: Object,
  })
  public value;

  public addOrRemoveLang(lang: string) {
    if (lang == "cn") {
      this.value.cn = !this.value.cn;
    }
    if (lang == "en") {
      this.value.en = !this.value.en;
    }
  }
}
